<h4 mat-dialog-title>
  @if (texteAdministrableTranslated) {
    {{ texteAdministrableTranslated.label }}
  }
</h4>
<mat-dialog-content style="min-height: 80px;">
  @if (texteAdministrableTranslated) {
    <div [innerHTML]="texteAdministrableTranslated.texte | safeHtml: 'html'"></div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn " [mat-dialog-close]="false">{{ 'general.close' | translate }}</button>
</mat-dialog-actions>
